// extracted by mini-css-extract-plugin
export var link = "_te-0";